import { EuiBadge, EuiBasicTable, EuiIcon, EuiSwitch, EuiText } from '@elastic/eui';
import React, { useMemo } from 'react';
import { CreateFecha, DiasMes, FinMes } from '../../../../../../shared/utils/fecha';
import { useUserSettings } from '../../../../context/CurrentUserContext';
import { PERFIL_ADMIN } from '../../../../../../shared/constanst/constants';


export const TablaValidacionFacturaExpatriados = (props:any) =>{

    const {currentUser} : any = useUserSettings();
    const {data, handleVbChange, handleProrrateoChange, translate, peridoSeleccion} = props;

    const columns: Array<any> = [
        {
            field: 'nombre',
            name: translate('nombre'),
            textOnly:true,
            truncateText: true,
            dataType: 'string',
            width: '20%',
            render: (data:string)=> <span title={data}>{data}</span>
        },
        {
          field: 'tipoEmpleado',
          name: translate('tipo'),
          textOnly:true,
          truncateText: true,
          dataType: 'string',
          align: 'center',
          render: (data:string)=> data===null ? <EuiText>{`-`}</EuiText> : <EuiBadge title={translate(data==='O'?'obra':'estructura')} color={data==='O'?'default':'danger'}>{data}</EuiBadge>
        },
        {
            field: 'fechaDesde',
            name: translate('fecha-desde'),
            dataType: 'date',
            render: (date: any) =>CreateFecha(date)
        },
        {
            field: 'fechaHasta',
            name: translate('fecha-hasta'),
            dataType: 'date',
            render: (date: any) =>CreateFecha(date)
        },
        {
          field: 'fechaFacturacionExpatriadoInicial',
          name: translate('facturacion-expatriado-desde'),
          dataType: 'date',
          render: (date: any) =>CreateFecha(date)
        },
        {
            field: 'fechaFacturacionExpatriadoFinal',
            name: translate('facturacion-expatriado-hasta'),
            dataType: 'date',
            render: (date: any) =>( date === null ? '-' :CreateFecha(date))
        },
        {
          field: 'diasFacturacion',
          name: translate('dias-facturacion'),
          dataType: 'number',
          align: 'center'
        },
        {
          field: 'vb',
          name: translate('visto-bueno'),
          dataType: 'boolean',
          align: 'center',
          render: (value:boolean, data:any) => {
            const {vb, idEmpleado, facturadoIrpf, facturadoRetHipot} = data
            const isDisabled =  (facturadoIrpf === true || facturadoRetHipot===true)
            return <EuiSwitch compressed disabled={isDisabled} checked={vb} onChange={(e:any)=>{handleVbChange(e.target.checked, idEmpleado)}} label="" showLabel={false}/>
          }
        },
        {
          field: 'facturadoIrpf',
          name: translate('facturacion-irpf'),
          dataType: 'boolean',
          align: 'center',
          render: (value:boolean, data:any) => {
            const color = value ? 'success' : 'danger';
            const icon = value ? 'check' : 'cross';
            return <EuiIcon size='m' type={icon} color={color}/>;
          }
        },
        {
          field: 'facturadoRetHipot',
          name: translate('facturacion-retencion-hipotetica'),
          dataType: 'boolean',
          align: 'center',
          render: (value:boolean, data:any) => {
            const color = value ? 'success' : 'danger';
            const icon = value ? 'check' : 'cross';
            return <EuiIcon size='m' type={icon} color={color}/>;
          }
        }
    ];


    if (currentUser.perfil === PERFIL_ADMIN)
    {
        const col={
          field: 'calcularProrrateo',
          name: 'Prorrateo',
          dataType: 'boolean',
          align: 'center',
          render: (value:boolean, data:any) => {
            const {diasFacturacion, idEmpleado, facturadoIrpf, facturadoRetHipot} = data
            const _diasMes = DiasMes(peridoSeleccion)
            const visible = diasFacturacion < _diasMes;
            const isDisabled =  (facturadoIrpf === true || facturadoRetHipot===true)
            return visible ? <EuiSwitch compressed disabled={isDisabled} checked={value} onChange={(e:any)=>{handleProrrateoChange(e.target.checked, idEmpleado)}} label="" showLabel={false}/> : null
          }
        }
      
        columns.splice(7,0, col);
    }

    

      const getRowProps = (user: any) => {
        const { vb } = user;
        return {
        //   'data-test-subj': `row-${id}`,
          className: vb ? 'table-validacion-expatriados-row' : '',
          //onClick: () => {},
        };
      };

      return (
        <EuiBasicTable
          className={'table-validacion-expatriados'}
          cellPadding={3}
          itemId="idEmpleado"
          tableCaption=""
          compressed={false}
          // isSelectable={true}
          // selection={selection}
          items={data}
          rowHeader="idEmpleado"
          columns={columns}
          rowProps={getRowProps}
        />
      );
}